<main class="flex justify-content-center wrapper-content mt-3  flex-column">
  <header class="lg:w-full w-11 mx-auto ">
    <h1 class="header-title mb-0 font-size-title  font-bold">
      {{ translations?.header }}
    </h1>
    <h2 class="app-text-gray mt-1 my-3 sm:mt-1 sm:mt-0 font-18 font-size-title w-fit font-normal">
      {{ translations?.subHeader }}
      <span class="font-bold text-blue-general"> {{ numeroRadicado() }}</span>
      {{ translations?.subHeader2 }}
    </h2>
  </header>
  <div class="  w-full md:justify-content-between justify-content-center grid mx-auto">
    <section class=" col-12 md:col-5 mx-auto md:mx-0 pl-0">
      <div class="app-card bg-gray-100 sm:px-5 px-3">
        <div>
          <h3 class="color-form-label my-0 ml-3 font-normal font-18">{{ translations.headerTransaction }}</h3>
        </div>
        <form class="grid font-principal mx-0 text-lg content-form bg-white p-3 ">
          <div class="col-7   border-none  border-bottom-1 border-gray-300	pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.ticket }}</label>
            <p class="color-form-label my-0 line-text-value"> {{ solicitudPse?.ticketId }}</p>
          </div>
          <div class="col-6   border-none  border-bottom-1 border-gray-300 flex flex-column pb-0	">
            <label class="app-text-gray line-text-label ">{{ translations.estado }}</label>
            <div class="inline-flex align-items-center py-0" [ngClass]="{'transaction-status--rejected': resultTransaction?.estado==='RECHAZADA',
           'transaction-status--approved':  resultTransaction?.estado==='APROBADA',
            'transaction-status':  resultTransaction?.estado==='PENDIENTE',
             'transaction-status-failed':  resultTransaction?.estado==='FALLIDA'}">
              <p class="my-0 line-text-value mr-2">{{ resultTransaction?.estado }}</p>
              <i class="pi pi-info-circle"></i>
            </div>
          </div>
          <div class="col-6   border-none  border-bottom-1 border-gray-300	pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.valorPago }}</label>
            <p class="color-form-label my-0 line-text-value"> $ {{ resultTransaction?.transValue |  number }}</p>
          </div>
          <div class="col-12   border-none  border-bottom-1 border-gray-300 pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.nombreBanco }}</label>
            <p class="color-form-label my-0 line-text-value">{{ resultTransaction?.bankName }}</p>
          </div>
          <div class="col-12   pb-0 border-none  border-bottom-1 border-gray-300">
            <label class="app-text-gray line-text-label ">{{ translations.tramite }}</label>
            <p class="color-form-label my-0 line-text-value">{{ resultTransaction?.descripcionPago }}</p>
          </div>
          <div class="col-6 border-none  border-bottom-1 border-gray-300 pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.fechaTransaccion }}</label>
            <p
              class="color-form-label my-0 line-text-value">{{ resultTransaction?.fechaTransaction | date: 'YYYY/MM/dd' }}</p>
          </div>
          <div class="col-6 border-none  border-bottom-1 border-gray-300 pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.horaTransaccion }}</label>
            <p
              class="color-form-label my-0 line-text-value">{{ resultTransaction?.fechaTransaction | date : 'mediumTime' }}</p>
          </div>
          <div class="col-6 border-none   border-gray-300 pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.cus }}</label>
            <p class="color-form-label my-0 line-text-value">{{ resultTransaction?.trazabilityCode }}</p>
          </div>
          <div class="col-6 border-none    border-gray-300 pb-0">
            <label class="app-text-gray line-text-label ">{{ translations.codServicio }}</label>
            <p class="color-form-label my-0 line-text-value">{{ resultTransaction?.serviceCode }}</p>
          </div>

          <div class="col-12 flex  justify-content-center mt-4">
            <button class="btn flex align-items-center" pButton type="button"
                    (click)="redirectToHome()">
              <span>{{ translations.volver }}</span>
              <i class="pi pi-save ml-2"></i>
            </button>
          </div>
        </form>
      </div>

    </section>
    <div class="col-12 md:col-7 section-right sm:pl-3 mx-auto md:mx-0 ">
      @if (url) {
        <iframe *ngIf="!isMobile else movil" class="w-full h-full" [title]="title()"
                [src]="url | safeResource : 'resourceUrl'"></iframe>
      } @else {
        <p-skeleton height="100%"></p-skeleton>
      }

    </div>

  </div>
</main>


<ng-template #movil>
  <div class="w-full h-20rem flex justify-content-center align-items-center bg-blue-100">
    <a target="_blank" [href]="url | safeResource : 'resourceUrl'" class="btn px-3 py-2  no-underline">
      <i class="pi pi-download"></i>
      <span class="px-2">{{ translations.descargar }}</span>
    </a>
  </div>
</ng-template>

